// 替代window, 用来存放一下全局性的数据和方法。方便以后迁移到其他平台
export default {
  // scrollToBottom: 滚动到页面底部。在 MixinSendMsg.js 完成赋值
  // sendTextMessage: 发送文本消息。在 MixinSendMsg.js 完成赋值
  // sendQDMenuMessage：发送不上屏的命令消息。在 MixinSendMsg.js 完成赋值
  // wpaDetail: 接待配置信息。在src/components-business/MixinLogin.js完成赋值
  // auth: undefined
};
